import { doRequest } from '@r1-frontend/do-request';
import getStateCatchUp, { ResponseDto } from '@r1-frontend/api-domru/api-profile/v1/catch-up/get-state-catch-up';

import { TAppThunkDispatch } from '~/src/store';
import { ECatchUpActionTypes } from '~/src/store/reducers/catchup';

// Получение текущего статуса
const saveCatchUpState = (stateStatus: ResponseDto) => ({
    type: ECatchUpActionTypes.SET_CATCHUP_STATUS_STATE,
    payload: stateStatus,
});

export const getCatchUpStatusState = (
    agreement_id: number,
) => {
    return async(dispatch: TAppThunkDispatch): Promise<void> => {
        const resp = await doRequest.apiProfile<ResponseDto>(
            getStateCatchUp({ agreement_id }),
        );
        if (!resp.isSuccess) {
            return;
        }
        dispatch(saveCatchUpState(resp.payload));
    };
};
